module.exports = "/img/_/_/_/assets/images//app_bar_background.png?57fb051bbbf2162295930eb0a2236fae";